import {
  Component,
  Input,
  AfterViewInit,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { IOption } from '../../shared/models/interfaces/option';
import { IOptionValue } from '../../shared/models/interfaces/option-value';
import { IOptionValueQuestionGroup } from "../../shared/models/interfaces/option-value-question-group";
import { DataService } from '../../shared/services/dataservice';
import * as _ from 'lodash';

@Component({
  selector: 'app-question-option',
  templateUrl: './question-option.component.html',
  styleUrls: ['./question-option.component.scss'],
})
export class QuestionOptionComponent implements OnInit, AfterViewInit {
  @Input() option: IOption;
  @Input() isReadOnly: boolean;
  @Input() isRequired: boolean;
  @Output() questionAnsweredEvent: EventEmitter<any> = new EventEmitter<any>();
  referralFormSubmitted = false;
  dropDownPreSelectedValue: number | null | undefined;
  trueFalsePreSelectedValue: number | undefined;
  radioButtonPreSelectedValue: number | undefined;
  placeHolderText = 'Please Select';
  private _sortedOptionVals: IOptionValue[];

  ngAfterViewInit(): void {
    this.dropDownPreSelectedValue =
      this.option.optionValues.find((x) => x.isSelected) &&
      this.option.optionValues.find((x) => x.isSelected)!.optionValueId;

    this.trueFalsePreSelectedValue =
      this.option.optionValues.find((x) => x.isSelected) &&
      this.option.optionValues.find((x) => x.isSelected)!.optionValueId;

    this.radioButtonPreSelectedValue =
      this.option.optionValues.find((x) => x.isSelected) &&
      this.option.optionValues.find((x) => x.isSelected)!.optionValueId;

    this.setSortedOptionVals();

    if (this.dropDownPreSelectedValue !== null) {
      this.placeHolderText = '';
    }
  }

  constructor(private dataService: DataService) {}
  ngOnInit(): void {
    this.dataService.currentReferralFormStatus.subscribe((value) => {
      this.referralFormSubmitted = value;
    });
  }

  dropDownSelectionChanged(
    selectedOptionValue: { optionValueId: number } | null
  ) {
    console.log(
      'selectedOptionValue [' +
        selectedOptionValue?.optionValueId.toString() +
        ']'
    );
    if (selectedOptionValue == null) {
      this.placeHolderText = 'Please Select';
    } else {
      this.placeHolderText = '';
    }
    if (selectedOptionValue?.optionValueId) {
      this.selectSingleOptionValue(selectedOptionValue.optionValueId);
      /*console.log(this.selectSingleOptionValue(selectedOptionValue.optionValueId));*/
    }
  }

  radioSelectionChanged(selectedOptionValue: MatRadioChange) {
    if (selectedOptionValue) {
      this.selectSingleOptionValue(selectedOptionValue.value);
    }
  }

  containsNestedQuestions(optionValue: IOptionValue): boolean {
    if (
      optionValue.isSelected &&
      optionValue.optionValueQuestionGroups &&
      optionValue.optionValueQuestionGroups.length > 0 &&
      optionValue.optionValueQuestionGroups[0].questionGroup
    ) {
      return true;
    } else {
      return false;
    }
  }

  containsNestedQuestionGroupQuestions(optionValueQG: IOptionValueQuestionGroup): boolean {
    if (
      optionValueQG &&
      optionValueQG.questionGroup &&
      optionValueQG.questionGroup.questionGroupQuestions &&
      optionValueQG.questionGroup.questionGroupQuestions.length > 0 &&
      optionValueQG.questionGroup.questionGroupQuestions[0].questionGroup
    ) {
      return true;
    } else {
      return false;
    }
  }

  containsHelpText(optionValue: IOptionValue): boolean {
    return !!optionValue.helpText && optionValue.helpText !== '';
  }

  private selectSingleOptionValue(optionValueId: number) {
    this.option.optionValues.forEach((ov) => {
      ov.isSelected = ov.optionValueId === optionValueId;
      this.triggerQuestionAnswered();
    });
  }

  isDisabled(): boolean {
    if (this.isReadOnly) {
      return true;
    }
    return false;
  }

  showError() {
    switch (this.option.optionTypeId) {
      case 1:
      case 6: {
        if (
          this.referralFormSubmitted &&
          this.isRequired &&
          (this.option.optionValues[0].description === null ||
            this.option.optionValues[0].description === '')
        ) {
          return true;
        }
        return false;
        break;
      }
      default: {
        if (
          this.referralFormSubmitted &&
          this.isRequired &&
          this.option.optionValues.filter((x) => x.isSelected).length === 0
        ) {
          return true;
        }
        return false;
        break;
      }
    }
  }

  onSearch($event: { term: string }) {
    if ($event.term == '') {
      this.placeHolderText = 'Please Select';
    }
  }

  setSortedOptionVals() {
    this._sortedOptionVals = this.option.optionValues;
    return this._sortedOptionVals.sort((a, b) =>
      a.description.localeCompare(b.description)
    );
  }

  triggerQuestionAnswered() {
    this.questionAnsweredEvent.next(null);
  }

  get sortedOptionVals() {
    return this._sortedOptionVals;
  }
}
